import React, {useEffect, useState} from 'react';
import config from "../../config";
import {useEntityObject} from "../../dynamic365";
import {Incident} from "../../dynamic365/entities/Incident";
import IncidentItem from "./incident-item";
import {dateToPersian, downloadBase64AsExcel, isDesktop, subtractDateToPersian, timeSince} from "../../utils/functions";
import {Divider} from "primereact/divider";
import Paginator from "../../components/Paginator";
import {InputText} from "primereact/inputtext";
import {Button} from "primereact/button";
import * as Iconly from 'react-iconly';
import * as Icons from '../../icons';
import {useNavigate} from "react-router-dom";
import ContactUs from "./contact-us";
import Faq from "./faq";
import {ProgressSpinner} from "primereact/progressspinner";
import NoCase from "./no-case";
import {useUser} from "../../auth/UserContext";
import {Dropdown} from "primereact/dropdown";
import DatePicker, {DateObject} from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import gregorian from "react-date-object/calendars/gregorian";
import gregorian_fa from "react-date-object/locales/gregorian_fa";



function Header({filter, report, reload}) {
    const user = useUser();
    const navigate = useNavigate();
    const [visibleSearchInput, setVisibleSearchInput] = useState(false);
    const [searchInput, setSearchInput] = useState();
    const [stateCode, setStateCode] = useState();
    const [dateRange, setDateRange] = useState();
    const [showFilters, setShowFilters] = useState(false);
    const [showFilterByDate, setShowFilterByDate] = useState(false);
    const stateItems = [
        {label: "درحال بررسی", statecode:0},
        {label: "حل شده", statecode:1},
        {label: "لغو شده", statecode:2},
    ]
    const [fromDate, setFromDate] = useState();
    const [toDate, setToDate] = useState();

    const currentCompany = ()=>{
        let index = user.state.userData.companies.findIndex((c)=>c.accountid === user.state.userData.customerid || c.AccountId === user.state.userData.customerid);
        return index>-1 && user.state.userData.companies[index]
    }

    return(
        <>
            <div className="flex w-full border-bottom-1 border-gray-300 h-4rem align-items-center">
                <div className="flex flex-1 align-items-center gap-2 p-3">
                    <span className={`p-2 text-sm cursor-pointer pi pi-sync`} onClick={()=>{reload(); setStateCode(undefined); setSearchInput("")}}/>
                    <div className="flex flex-column">
                        <span className="text-sm font-bold">{currentCompany()?currentCompany().Name:"همه شرکت ها"}</span>
                        <span className="text-xs">{/*Description*/}</span>
                    </div>
                </div>
                <div className="p-3 flex lg:hidden gap-2">
                    {/*<span className="p-1 cursor-pointer flex align-items-center" onClick={()=>{report(filterBy, {value:searchInput})}} ><Iconly.Download/></span>*/}
                    <span className="p-1 cursor-pointer flex align-items-center" onClick={()=>{setVisibleSearchInput(!visibleSearchInput)}}><Iconly.Search/></span>
                    <div className="flex align-items-center">
                        {
                            stateCode?(
                                <div className="flex align-items-center gap-2 border-1 border-round-xl p-1 pl-2 pr-2">
                                    <span className="pi pi-times" onClick={()=>{setStateCode(undefined); filter({stateCode, searchInput, dateRange}); }}/>
                                    <span>{stateCode.label}</span>
                                </div>
                            ):(<span className="p-1 cursor-pointer flex align-items-center" onClick={()=>{setShowFilters(!showFilters)}}>
                                <Iconly.Filter2/>
                            </span>)
                        }
                    </div>
                    <span className="p-1 cursor-pointer flex align-items-center" onClick={()=>{navigate("/case/create")}}><Iconly.Plus/></span>
                </div>
                <div className="hidden lg:flex p-3">
                    <div className="flex gap-2">
                        <Button className="p-button-plain bg-white p-button-outlined text-xs p-button-sm border-round-xl pt-2 pb-2 pl-5 h-fit" label="گزارش گیری" onClick={()=>{report({stateCode, searchInput, dateRange});}} icon="pi pi-file-excel ml-2"/>
                        <span className="p-input-icon-left rtl">
                            <InputText value={searchInput} onChange={(e)=>{setSearchInput(e.target.value)}} className="p-2 border-round-xl text-xs w-18rem" onKeyDown={(e)=>{e.code==='Enter' && filter({stateCode, searchInput, dateRange});}} placeholder="جستجو"/>
                            <i className={`cursor-pointer pi pi-search`} onClick={()=>{filter({stateCode, searchInput, dateRange});}} />
                        </span>
                        <div className="relative">
                            <Button className="p-button-plain bg-white p-button-outlined text-xs p-button-sm border-round-xl pt-2 pb-2 pr-3 pl-3 flex gap-2" >
                                {
                                    stateCode?(
                                        <>
                                            <span className="pi pi-times" onClick={()=>{setStateCode(undefined); filter({stateCode:undefined, searchInput, dateRange})}}/>
                                            <span>{stateCode.label}</span>
                                        </>
                                    ):(
                                        <div className="flex gap-2 align-items-center" onClick={()=>{setShowFilters(!showFilters)}}>
                                            <Icons.Setting/>
                                            <span>{"فیلتر"}</span>
                                        </div>)
                                }
                            </Button>
                            <div className={`absolute ${showFilters ?"flex flex-column":"hidden"} w-20rem bg-white border-round-2xl p-3 z-5 shadow-2 gap-2 left-50 top-100 mt-6`} style={{transform: 'translate(-50%, -40%)'}} onMouseLeave={()=>{setShowFilters(false)}}>
                                <div className="flex gap-2 align-items-center w-full">
                                    {
                                        showFilterByDate ? (
                                            <>
                                                <span className="text-xs">از</span>
                                                <DatePicker calendar={persian} minDate={new DateObject({ calendar: persian }).subtract(3, "month")} maxDate={new DateObject({ calendar: persian })} locale={persian_fa} containerClassName="w-full" format="YYYY-MM-DD" calendarPosition="bottom-center" onChange={(e)=>{setFromDate(e);setDateRange({fromDate:new DateObject(e).convert(gregorian, gregorian_fa).format(), toDate:toDate?new DateObject(toDate).convert(gregorian, gregorian_fa).format():undefined}); filter({stateCode, searchInput, dateRange:{fromDate:new DateObject(e).convert(gregorian, gregorian_fa).format(), toDate:toDate?new DateObject(toDate).convert(gregorian, gregorian_fa).format():undefined}});}} value={fromDate} monthYearSeparator=" " digits={[0,1,2,3,4,5,6,7,8,9]} render={(value, openCalendar)=>(<Button className="w-full p-button-outlined p-button-plain text-xs pt-2 pb-2 border-round-xl white-space-nowrap flex gap-2 align-items-center" label={value} onClick={openCalendar}/>)}/>
                                                <span className="text-xs">تا</span>
                                                <DatePicker calendar={persian} minDate={new DateObject({ calendar: persian }).subtract(3, "month")} maxDate={new DateObject({ calendar: persian })} locale={persian_fa} containerClassName="w-full" format="YYYY-MM-DD" calendarPosition="bottom-center" onChange={(e)=>{setToDate(e);setDateRange({fromDate:fromDate?new DateObject(fromDate).convert(gregorian, gregorian_fa).format():undefined, toDate:new DateObject(e).convert(gregorian, gregorian_fa).format()}); filter({stateCode, searchInput, dateRange:{fromDate:fromDate?new DateObject(fromDate).convert(gregorian, gregorian_fa).format():undefined, toDate:new DateObject(e).convert(gregorian, gregorian_fa).format()}});}} value={toDate} monthYearSeparator=" " digits={[0,1,2,3,4,5,6,7,8,9]} render={(value, openCalendar)=>(<Button className="w-full p-button-outlined p-button-plain text-xs pt-2 pb-2 border-round-xl white-space-nowrap flex gap-2 align-items-center" label={value} onClick={openCalendar}/>)}/>
                                                <Button className="p-button-outlined w-6rem p-button-icon-only p-button-plain text-xs pt-2 pb-2 border-round-xl" icon="pi pi-times" onClick={()=>{setShowFilterByDate(false); setToDate(undefined); setFromDate(undefined); setDateRange(undefined); filter({stateCode, searchInput, dateRange:undefined})}}/>
                                            </>
                                        ):(
                                            <Button className="w-full p-button-outlined p-button-plain text-xs pt-2 pb-2 border-round-xl white-space-nowrap flex gap-2 align-items-center" label="فیلتر بر اساس تاریخ" onClick={()=>{setShowFilterByDate(true); setToDate(new DateObject()); }}/>
                                        )
                                    }

                                </div>
                                <div className="flex gap-2">
                                    {stateItems.map((f)=>(<Button className="p-button-outlined p-button-plain text-xs pt-2 pb-2 border-round-xl white-space-nowrap" label={f.label} onClick={()=>{setStateCode(f); filter({stateCode:f, searchInput, dateRange}); setShowFilters(false);}}/>))}
                                </div>
                            </div>
                        </div>
                        <Button className="p-button-plain bg-white p-button-outlined text-xs p-button-sm border-round-xl pt-2 pb-2 pl-5" icon="pi pi-plus ml-2 text-xs" label="درخواست جدید" onClick={()=>{navigate("/case/create")}}/>
                    </div>
                </div>
            </div>
            {
                visibleSearchInput && !isDesktop() && (
                    <div className="p-2 pl-3 pr-3">
                        <span className="p-input-icon-left rtl w-full">
                            <InputText value={searchInput} onChange={(e)=>{setSearchInput(e.target.value)}} className="border-round-xl w-full" onKeyDown={(e)=>{e.key==='Enter' && filter({stateCode, searchInput, dateRange})}} placeholder="جستجو"/>
                            <i className={`cursor-pointer pi pi-search`} onClick={()=>{filter({stateCode, searchInput, dateRange});}} />
                        </span>
                    </div>
                )
            }
            {
                showFilters && !isDesktop() && (
                    <div className="p-2 flex gap-2  pl-3 pr-3">
                        {stateItems.map((f)=>(<Button className="p-button-outlined flex-grow-1 p-button-plain text-xs pt-2 pb-2 border-round-xl white-space-nowrap" label={f.label} onClick={()=>{setStateCode(f); filter({stateCode:f, searchInput, dateRange}); setShowFilters(false);}}/>))}
                    </div>
                )
            }
        </>
    )
}

function Index(props) {
    const incidentEntity = useEntityObject(Incident());
    const [cases, setCases] = useState([]);
    const [pageIndex, setPageIndex] = useState(1);
    const [loading, setLoading] = useState(false);
    const user = useUser();
    const [stateCode,setStateCode] = useState();
    const [searchInput,setSearchInput] = useState();
    const [dateRange,setDateRange] = useState();
    // console.log(user.state.userData)


    useEffect(()=>{
        // console.log(stateCode, searchInput, dateRange)
        getCases({stateCode, searchInput, dateRange});
    },[pageIndex, user.state.userData.customerid, stateCode, searchInput, dateRange])

    const getCases = ({stateCode, searchInput, dateRange})=>{
        setLoading(true);
        let customerid = user.state.userData.customerid?user.state.userData.customerid:user.state.userData.account.AccountId;
        let xmlFilter = null;


        if (searchInput){
            xmlFilter = `<filter type="and" >
                             ${customerid === -1 ? `
                                <condition attribute="customerid" operator="in">
                                    ${user.state.userData.companies.map(c => (`<value uitype=\"account\">{${c.accountid ? c.accountid : c.AccountId}}</value>`)).join("")}
                                </condition>
                            ` : `
                                <condition attribute="customerid" operator="eq" value="${customerid ? customerid : "$accountId"}" />
                                `}
                           ${stateCode ? `<condition attribute="statecode" operator="eq" value="${stateCode.statecode}" />`:""}
                           ${dateRange ? `<condition attribute="createdon" operator="on-or-after" value="${dateRange.fromDate}" /><condition attribute="createdon" operator="on-or-before" value="${dateRange.toDate}" />`:""}

                           <filter type="or" >
                               <condition attribute="title" operator="like" value="%${searchInput}%" />
                               <condition attribute="description" operator="like" value="%${searchInput}%" />
                               <condition attribute="ticketnumber" operator="like" value="%${searchInput}%" />
                           </filter>
                         </filter>`
        }

        else {
            xmlFilter = `<filter type="and">
                            ${customerid === -1 ? `
                                <condition attribute="customerid" operator="in">
                                    ${user.state.userData.companies.map(c => (`<value uitype=\"account\">{${c.accountid ? c.accountid : c.AccountId}}</value>`)).join("")}
                                </condition>
                            ` : `
                                <condition attribute="customerid" operator="eq" value="${customerid ? customerid : "$accountId"}" />
                                `}
                           ${stateCode ? `<condition attribute="statecode" operator="eq" value="${stateCode.statecode}" />`:""}
                           ${dateRange ? `<condition attribute="createdon" operator="on-or-after" value="${dateRange.fromDate}" /><condition attribute="createdon" operator="on-or-before" value="${dateRange.toDate}" />`:""}
                         </filter>`
        }

        incidentEntity.fetch({
            onResult:({data:{value}})=>{
                // console.log(value)
                setCases(value);
                setLoading(false);
            },
            onError:(e)=>{
                setLoading(false);
            },
            count:dateRange?200:20,
            page:pageIndex,
            // filters,
            // filterType:"or",
            xmlFilter,
            orderBy:[{attributeName: incidentEntity.entity.fields.modifiedon, descending:true}]
        })
    }

    // Group the data by date
    const groupedData = cases.reduce((result, item) => {
        // Extract the date from the item
        const date = timeSince(new Date(item.modifiedon).getTime()/1000);

        // Check if the date is already a key in the result object
        if (!result[date]) {
            // If not, create a new array for that date
            result[date] = [];
        }

        // Push the item to the array corresponding to its date
        result[date].push(item);

        return result;
    }, {});

    // Convert the grouped data object back to an array
    const groupedCases = Object.entries(groupedData).map(([date, items]) => ({
        date,
        items,
    }));

    const createReport=({stateCode=null, searchInput=null, dateRange=null})=>{

        let customerid = user.state.userData.customerid?user.state.userData.customerid:user.state.userData.account.AccountId;
        let xmlFilter = null;
        if (searchInput){
            xmlFilter = `<filter type="and" >
                             ${customerid===-1?`
                                <condition attribute="customerid" operator="in">
                                    ${user.state.userData.companies.map(c=>(`<value uitype=\"account\">{${c.accountid?c.accountid:c.AccountId}}</value>`)).join("")} 
                                </condition>
                            `:`
                                <condition attribute="customerid" operator="eq" value="${customerid?customerid:"$accountId"}" />
                                `}
                           ${stateCode ? `<condition attribute="statecode" operator="eq" value="${stateCode.statecode}" />`:""}
                           ${dateRange ? `<condition attribute="createdon" operator="on-or-after" value="${dateRange.fromDate}" /><condition attribute="createdon" operator="on-or-before" value="${dateRange.toDate}" />`:""}

                           <filter type="or" >
                               <condition attribute="title" operator="like" value="%${searchInput}%" />
                               <condition attribute="description" operator="like" value="%${searchInput}%" />
                               <condition attribute="ticketnumber" operator="like" value="%${searchInput}%" />
                           </filter>
                         </filter>`
        }
        else {
            xmlFilter = `<filter type="and">
                            ${customerid===-1?`
                                <condition attribute="customerid" operator="in">
                                    ${user.state.userData.companies.map(c=>(`<value uitype=\"account\">{${c.accountid?c.accountid:c.AccountId}}</value>`)).join("")} 
                                </condition>
                            `:`
                                <condition attribute="customerid" operator="eq" value="${customerid?customerid:"$accountId"}" />
                                `}
                           ${stateCode ? `<condition attribute="statecode" operator="eq" value="${stateCode.statecode}" />`:""}
                           ${dateRange ? `<condition attribute="createdon" operator="on-or-after" value="${dateRange.fromDate}" /><condition attribute="createdon" operator="on-or-before" value="${dateRange.toDate}" />`:""}
                         </filter>`
        }


        incidentEntity.toExcel({
            onResult:({data})=>{
                setLoading(false);
                downloadBase64AsExcel(data, `report.xlsx`);
            },
            onError:(e)=>{
                setLoading(false);
            },
            fields:[
                "ticketnumber",
                "title",
                "description",
                "primarycontactid",
                "customerid",
                "createdon",
                "kph_lastresponsetime",
                "statecode"
            ],
            fieldsTranslate:{
                "ticketnumber":{formated_key:"ticketnumber", value:"شماره تیکت"},
                "title":{formated_key:"title", value:"عنوان"},
                "description":{formated_key:"description", value:"شرح"},
                "primarycontactid":{formated_key:"_primarycontactid_value@OData.Community.Display.V1.FormattedValue", value:"ثبت کننده"},
                "customerid":{formated_key:"_customerid_value@OData.Community.Display.V1.FormattedValue", value:"شرکت"},
                "createdon":{formated_key:"createdon@OData.Community.Display.V1.FormattedValue", value:"تاریخ ایجاد"},
                "kph_lastresponsetime":{formated_key:"kph_lastresponsetime@OData.Community.Display.V1.FormattedValue", value:"تاریخ آخرین بروزرسانی"},
                "statecode":{formated_key:"statecode@OData.Community.Display.V1.FormattedValue", value:"وضعیت"}
            },
            count:500,//dateRange?500:20,
            // fileName:'test.xslx',
            page:pageIndex,
            // filters,
            xmlFilter,
            orderBy:[{attributeName: incidentEntity.entity.fields.modifiedon, descending:true}]
        })
    }

    return (
        <div className="flex flex-column h-full w-full">
            {/*Place page header hear...*/}
            <Header filter={({stateCode, searchInput, dateRange})=>{setStateCode(stateCode); setSearchInput(searchInput); setDateRange(dateRange)}} report={({stateCode, searchInput, dateRange})=>{createReport({stateCode, searchInput, dateRange})}} reload={()=>{setStateCode(undefined); setSearchInput(undefined); setDateRange(undefined); setPageIndex(1); if (pageIndex===1)getCases({stateCode, searchInput, dateRange})}}/>
            <div className="flex-grow-1 h-1rem overflow-y-auto">
                {/*Place page content hear...*/}
                <div className="flex h-full w-full justify-content-center">
                    <div className="w-full lg:w-8 p-4">
                        {!loading ? (
                            <>
                                {
                                    groupedCases.length>0?groupedCases.map(({ date, items }) => (
                                        <div key={date}>
                                            <div className="flex align-items-center gap-4">
                                                <span className="flex-grow-1 border-bottom-1 max-h-0 border-gray-300"/>
                                                <span className="text-gray-500">{date}</span>
                                                <span className="flex-grow-1 border-bottom-1 max-h-0 border-gray-300"/>
                                            </div>
                                            {items.map((data) => (
                                                <IncidentItem key={data['odata.etag']} data={data}/>
                                            ))}
                                        </div>
                                    )):(
                                        <NoCase/>
                                    )
                                }
                                {
                                    cases.length>=20 && (<Paginator currentPage={pageIndex} setPageIndex={setPageIndex}/>)
                                }
                            </>):(<div className="flex justify-content-center align-items-center"><ProgressSpinner/></div>)
                        }
                        {/*<Faq/>*/}
                        {/*<ContactUs/>*/}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Index;